import React from 'react';
import { footerNotes } from '../data/mock';

const CTASection = () => {
  return (
    <section className="w-full">
      {/* Footer Notes */}
      <div className="bg-gray-100 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-xs text-gray-500 space-y-1">
            {footerNotes.map((note, index) => (
              <p key={index}>{note}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
